export enum MutationTypes {
  COMPANY_SET_WIZARD = "COMPANY_SET_WIZARD",
  COMPANY_SET_COMPANY = "COMPANY_SET_COMPANY"
}
